import { Routes, Route } from 'react-router-dom'
import Navbar from './components/Navbar'
import Footer from './components/Footer'
import ScrollToTop from './components/ScrollToTop'
import HomePage from './pages/HomePage'
import AboutPage from './pages/AboutPage'
import MethodPage from './pages/MethodPage'
import ArchetypesPage from './pages/ArchetypesPage'
import BookPage from './pages/BookPage'
import BlogPage from './pages/BlogPage'
import ArticlePage from './pages/ArticlePage'
import LeadsDashboardPage from './pages/LeadsDashboardPage'
import NerdPowerPage from './pages/NerdPowerPage'

export default function App() {
  return (
    <div className="relative min-h-screen" style={{ background: '#050510' }}>
      <ScrollToTop />
      <Navbar />
      <div className="pt-14">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/metodo" element={<MethodPage />} />
          <Route path="/archetipi" element={<ArchetypesPage />} />
          <Route path="/libro" element={<BookPage />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/blog/:slug" element={<ArticlePage />} />
          <Route path="/gilda-admin" element={<LeadsDashboardPage />} />
          <Route path="/nerd-power" element={<NerdPowerPage />} />
        </Routes>
      </div>
      <Footer />
    </div>
  )
}
